import { createDataTestSelector } from '../../createDataTestSelector'

export default {
  passwordInput: createDataTestSelector('unlock-password'),
  submitButton: createDataTestSelector('unlock-submit')
}
